import {
  useContext,
} from 'react';
import {Context} from '../contexts/WordList';
import {fetchWords} from '../helpers/localApi';

export function useSearchWords() {
  const [state, dispatch] = useContext(Context);
  const {orderBy, language} = state;

  const searchWords = async (searchWord) => {
    if (searchWord === undefined) return;

    if (searchWord !== '') {
      try {
        const itemsFromDb = await fetchWords({
          language,
          orderBy,
          search: searchWord,
        });

        dispatch({type: 'GET_WORDS', payload: itemsFromDb});

        if ( itemsFromDb.length > 0) {
          if (orderBy === 'wordEn') {
            dispatch({
              type: 'SET_LAST_WORD',
              payload: itemsFromDb[itemsFromDb.length - 1].wordEn,
            });
          } else {
            dispatch({
              type: 'SET_LAST_WORD',
              payload: itemsFromDb[itemsFromDb.length - 1].wordFa,
            });
          }
        }
      } catch (error) {
        dispatch({type: 'GET_WORDS', payload: []});
      }
    }
  };

  return {searchWords};
};
